<template>
  <v-dialog
    v-model="opened"
    transition="dialog-bottom-transition"
    hide-overlay
    fullscreen
  >
    <v-card tile>
      <v-card-title class="modal__title px-4 pt-4 pb-4">
        <span>{{$t('impersonate.action')}}</span>
        <v-spacer/>
        <v-btn @click="closeModal" color="primary" icon>
          <v-icon>
            mdi-close
          </v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-5 white text-body-1">
        <div class="mw-700 py-5 mx-auto">
          <v-tabs v-model="currentTab" color="realEstate" grow>
            <v-tab v-for="tab in tabs" :key="tab.value">
              {{ tab.title }}
            </v-tab>
          </v-tabs>
          <v-divider/>
        </div>

        <v-tabs-items v-model="currentTab">
          <v-tab-item key="info">
            <div class="mw-700 py-5 mx-auto">
              <h3>{{$t('impersonate.confirmation', {name})}}</h3>

              <v-row>
                <v-col cols="12">
                  <v-card-text class="pt-5 white text-body-1">
                    <p class="text-body-1" v-html="$t('impersonate.details')" />

                    <ul class="mt-5">
                      <li><b>{{ $t('impersonate.name') }}</b>: {{ name }}</li>
                      <li><b>{{ $t('impersonate.email') }}</b>: {{ email }}</li>
                    </ul>

                    <p class="text-body-1 mt-5">{{$t('impersonate.details2')}}</p>

                    <div class="d-flex justify-center mt-5">
                      <v-btn
                        elevation="0"
                        color="primary"
                        :loading="isLoading"
                        large
                        block
                        @click="performImpersonate"
                      >
                        {{ $t('impersonate.perform') }}
                      </v-btn>
                    </div>
                  </v-card-text>
                </v-col>
              </v-row>

              <v-divider class="mb-10"/>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex'
import {impersonate} from "@/services/auth/impersonate";

export default {
  name: 'ModalImpersonate',

  data() {
    return {
      opened: false,
      currentTab: 'info',
      name: '',
      email: '',
      id: ''
    }
  },

  computed: {
    ...mapGetters(['host', 'hausefulUser', 'isLoading']),

    tabs() {
      return [{value: 'info', title: 'Transformar'}]
    },
  },

  methods: {
    ...mapMutations(['setHost', 'setHausefulUser']),
    ...mapActions(['fetchHost', 'fetchHausefulUser']),

    performImpersonate() {
      impersonate(this.id)
    },

    openModal(userId, userType) {
      const actionHandlers = {
        'host': {
          fetcher: this.fetchHost,
          setter: this.setHost,
          setData: () => {
            this.name = this.host.name
            this.email = this.host.username
            this.id = this.host.id
          }
        },
        'hausefulUser': {
          fetcher: this.fetchHausefulUser,
          setter: this.setHausefulUser,
          setData: () => {
            this.name = this.hausefulUser.name
            this.email = this.hausefulUser.username
            this.id = this.hausefulUser.id
          }
        },
      }

      const handler = actionHandlers[userType]

      Promise.resolve(handler.setter({}))
        .then(async () => {
          await handler.fetcher(userId)
          handler.setData()
          this.opened = true
        })
    },

    closeModal() {
      this.opened = false
    },
  },
}
</script>
